import React from 'react';
import { FaPhoneAlt, FaPlay } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-glow-1"></div>
      <div className="hero-glow-2"></div>
      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="pulse-dot"></span>
            Welcome to Nodex Global LLC
          </div>
          <h1 className="hero-title">
            Grow Faster With A <br/>
            <span className="highlight">Digital Marketing</span> Partner That Delivers
          </h1>
          <p className="hero-description">
            We help business leaders drive revenue through digital performance-based marketing. See what a completely transparent, data-driven approach can do for your growth.
          </p>
          <div className="hero-actions">
            <a href="#contact" className="btn btn-primary">Start Your Growth</a>
            <a href="#services" className="btn btn-outline play-btn">
              <div className="play-icon-wrapper"><FaPlay className="play-icon"/></div>
              See How It Works
            </a>
          </div>
          
          <div className="hero-stats">
            <div className="stat-sm">
              <strong>98%</strong>
              <span>Client Retention</span>
            </div>
          </div>
        </div>
        <div className="hero-image-wrapper">
          <div className="image-decoration dot-pattern"></div>
          <div className="image-frame">
            <img 
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&q=80&w=800" 
              alt="Marketing Team Collaboration" 
              className="hero-image"
            />
            <div className="floating-card card-1">
              <div className="card-icon">📈</div>
              <div className="card-text">
                <strong>+145%</strong>
                <span>Traffic Growth</span>
              </div>
            </div>
            <div className="floating-card card-2">
              <div className="card-icon">🎯</div>
              <div className="card-text">
                <strong>Targeted</strong>
                <span>Campaigns</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
